import React, { useState } from "react";
import { Icon } from "@iconify/react";
import style from "./Customer.module.css";

export default function RateOfInterestTable({
  allCategories,
  handleEditData,
  searchInput,
  setSearchInput,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPages, setRowsPerPages] = useState(25); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const filteredData = searchInput
    ? allCategories.filter((item) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    : allCategories || []; // Ensuring it's always an array

  const displayedData = Array.isArray(filteredData)
    ? filteredData.slice(
        (currentPage - 1) * rowsPerPages,
        currentPage * rowsPerPages
      )
    : []; // Ensuring it's always an array

  const totalPages = Math.ceil(filteredData.length / rowsPerPages);

  const handlePageClick = (page) => {
    if (page <= totalPages) setCurrentPage(page); // Only set page if it's within range
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setCurrentPage(1); // Reset to first page whenever rows per page changes
  };

  // Preprocessing data for the table rows
  const preprocessedData = displayedData.map((x, idx) => ({
    SrNo: idx + 1,
    RateOfInterest: x.RateOfInterest, // Assuming this is the property from the data
  }));

  return (
    <>
      <div className={style["table-container"]}>
        <table className={style["custom-table"]}>
          <thead style={{ backgroundColor: "#627383", color: "#FFFFFF" }}>
            <tr>
              <th
                style={{
                  padding: "8px",
                  border: "1px solid #ccc",
                  textAlign: "center",
                  backgroundColor: "#627383",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "600",
                  minWidth: "fit-content",
                }}
              >
                Sr.No
              </th>
              <th
                style={{
                  padding: "8px",
                  border: "1px solid #ccc",
                  textAlign: "center",
                  backgroundColor: "#627383",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "600",
                  minWidth: "fit-content",
                }}
              >
                Rate Of Interest %
              </th>
              <th
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  right: 0,
                  background: "#627282",
                  zIndex: 1,
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {preprocessedData.map((x, idx) => (
              <tr
                key={x.SrNo}
                className={`${style.tableRow} ${
                  idx % 2 === 0 ? style.evenRow : style.oddRow
                }`}
              >
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {x.SrNo}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {x.RateOfInterest}
                </td>
                <td
                  style={{
                    fontSize: "12px",
                    position: "sticky",
                    right: -9,
                    zIndex: 1,
                    textAlign: "center",
                  }}
                >
                  <div className={style["action-container"]}>
                    <Icon
                      onClick={() => handleEditData(x)}
                      style={{ color: "#627282", cursor: "pointer" }}
                      icon="material-symbols-light:edit-outline"
                      width="20"
                      height="20"
                    />
                    <Icon
                      style={{ color: "#627282", cursor: "pointer" }}
                      icon="weui:delete-filled"
                      width="20"
                      height="20"
                    />
                    <Icon
                      style={{ color: "#627282", cursor: "pointer" }}
                      icon="ic:outline-print"
                      width="20"
                      height="20"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={style["page-controls"]}>
        <div className={style["pagination"]}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <div
              key={page}
              className={
                currentPage === page
                  ? style["pagination-pages-active"]
                  : style["pagination-pages"]
              }
              onClick={() => handlePageClick(page)}
            >
              {page}
            </div>
          ))}
        </div>

        <div className={style["rows-per-page"]}>
          <label htmlFor="rows-per-page">Rows per page</label>
          <select
            id="rows-per-page"
            value={rowsPerPages}
            onChange={handleRowsPerPageChange}
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    </>
  );
}
